/* A person named by an identifier: the name in the reading face, the bare identifier in the mono
   face so it reads as an identifier and not as an unfinished screen. Tokens only (ADR-0007). */

.name {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.id {
  font-family: var(--mono);
  font-size: var(--t-min);
  color: var(--ink-2);
  overflow-wrap: anywhere;
}

a.id {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* A link is a target: the identifier is a 14px-tall line in the mono face, under the 24px
   minimum the accessibility sweep holds every control to (WCAG 2.2, 2.5.8). The box is made
   taller; the text is unchanged. */
a.id,
a.name {
  display: inline-block;
  min-block-size: 24px;
  line-height: 24px;
}
